import { organisations } from './organisations';
import { residents } from './residents';
import { devices } from './devices';
import { familyMembers } from './family-members';
import { staff } from './staff';

export const API = {
  organisations,
  residents,
  devices,
  familyMembers,
  staff,
};
